import { ReduxState } from '../types';
import { AlertConfig, AlertState } from './alertTypes';

const getAlertState = (state: ReduxState): AlertState => {
  return state.alert;
};

export const getIsAlertVisible = (state: ReduxState): boolean => {
  return getAlertState(state).isAlertVisible;
};

export const getAlertConfig = (state: ReduxState): AlertConfig => {
  return getAlertState(state).config;
};
